<template>
  <div class="order-query">
    <!-- 同步订单 -->
    <div class="sync-section" v-if="isAdmin && tabIndex === 1">
      <div class="form-group">
        <label @click="tabIndex = 0">开始时间：</label>
        <el-date-picker v-model="syncForm.startTime" type="datetime" align="right" placeholder="选择开始时间"
          format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" @change="onSyncTimeChange">
        </el-date-picker>
      </div>
      <div class="form-group">
        <label>结束时间：</label>
        <el-date-picker v-model="syncForm.endTime" type="datetime" align="right" placeholder="选择结束时间"
          format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" @change="onSyncTimeChange">
        </el-date-picker>
      </div>
      <div class="form-group">
        <label>时间类型：</label>
        <el-select v-model="syncForm.timeType" placeholder="选择时间类型" style="width: 100%;">
          <el-option label="下单时间" value="orderTime"></el-option>
          <el-option label="更新时间" value="updateTime"></el-option>
          <el-option label="完成时间" value="finishTime"></el-option>
        </el-select>
      </div>
      <div class="form-group">
        <label>同步凭证：</label>
        <el-radio-group v-model="syncAppKeyMode" size="small" style="display: flex;">
          <el-radio-button label="primary">主用</el-radio-button>
          <el-radio-button label="secondary">备用</el-radio-button>
        </el-radio-group>
      </div>
      <button @click="syncOrders" :disabled="syncing || !canSync">
        {{ syncing ? '同步中...' : '同步订单' }}
      </button>
      <button v-if="isAdmin" @click="syncAllOrders" :disabled="syncing" style="margin-left: 10px; background: #ff6b6b;">
        {{ syncing ? '同步中...' : '同步所有订单' }}
      </button>
    </div>

    <!-- 查询订单 -->
    <div class="query-section" v-if="tabIndex === 0">
      <div class="form-row">
        <!-- <div v-if="!isAdmin" class="form-group">
          <label>推广位ID：</label>
          <el-input :value="userPositionId" disabled />
        </div> -->
        <div v-if="isAdmin || isLeader" class="form-group">
          <label @click="tabIndex = 1">推广位：</label>
          <el-select v-model="queryForm.positionId" placeholder="全部" clearable>
            <el-option label="全部" value="" />
            <el-option v-for="pos in positions" :key="pos.id || pos.positionId" :label="getPositionLabel(pos)"
              :value="pos.positionId" />
          </el-select>
        </div>
        <div class="form-group">
          <label>订单号：</label>
          <el-input v-model="queryForm.orderId" placeholder="订单号" clearable />
        </div>
        <!-- <div class="form-group">
          <label>商品ID：</label>
          <el-input v-model="queryForm.skuId" placeholder="商品ID" clearable />
        </div> -->
      </div>
      <div class="form-row">
        <div class="form-group">
          <div class="time-range-buttons">
            <button v-for="option in timeRangeOptions" :key="option.value" type="button"
              :class="['range-btn', { active: selectedTimeRange === option.value }]"
              @click="onTimeRangeSelect(option.value)">
              {{ option.label }}
            </button>
          </div>

        </div>
        <div class="form-group">
          <div class="filter-buttons">
            <button v-for="opt in statusOptions" :key="opt.value" type="button"
              :class="['range-btn', { active: selectedStatus === opt.value }]"
              @click="selectedStatus = opt.value; onStatusChange()">
              {{ opt.label }}
            </button>
          </div>
        </div>
        <!-- <div class="form-group">
          <label>开始时间：</label>
          <el-input v-model="queryForm.startTime" type="datetime-local" clearable />
        </div>
        <div class="form-group">
          <label>结束时间：</label>
          <el-input v-model="queryForm.endTime" type="datetime-local" clearable />
        </div> -->
        <!-- <div class="form-group">
          <label>时间类型：</label>
          <select v-model="queryForm.timeType">
            <option value="modify">按更新时间</option>
            <option value="order">按下单时间</option>
          </select>
        </div> -->
        <!-- <div class="form-group">
          <label>页码：</label>
          <el-input v-model.number="queryForm.pageIndex" type="number" min="1" clearable />
        </div>
        <div class="form-group">
          <label>每页大小：</label>
          <el-input v-model.number="queryForm.pageSize" type="number" min="1" max="100" clearable />
        </div> -->
      </div>
      <button @click="queryOrders()" :disabled="querying" style="width: 100%;">
        {{ querying ? '查询中...' : '查询订单' }}
      </button>
    </div>

    <!-- 订单列表 -->
    <div class="results-section" ref="resultsSection" @scroll="handleScroll" v-if="orderResults">
      <div class="stats">
        <div class="stat-item">
          <span class="stat-label">查询结果</span>
          <span class="stat-value">{{ orderResults.total || 0 }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">有效订单量</span>
          <span class="stat-value">{{ orderResults.totalValidOrders || 0 }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">有效成交金</span>
          <span class="stat-value">¥{{ (orderResults.totalValidAmount || 0).toFixed(2) }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">有效佣金</span>
          <span class="stat-value">¥{{ (orderResults.totalValidCommission || 0).toFixed(2) }}</span>
        </div>
      </div>

      <div class="order-cards" :class="{ 'loading': querying }">
        <div class="order-card" v-for="order in (orderResults && orderResults.orders) || []" :key="order.id">
          <div class="card-header">
            <div>
              <div class="order-time">
                <span v-if="order.subUnionId == 'DTY_87'" style="color: #42b983;">DIF</span>
                下单: {{ formatDateTime(order.orderTime) || '--' }}
              </div>
              <div class="order-time">
                <span v-if="order.finishTime">完成: {{ formatDateTime(order.finishTime).slice(0, 10) }}</span>
              </div>
            </div>
            <div>
              <span
                style="border: #42b983 1px solid;color: #42b983;padding: 0px 4px;border-radius: 4px;margin-right: 10px;font-size: 14px;">{{
                  order.traceType == 3 ? '跨店' : '同店' }}</span>
              <span class="status-pill" :class="statusClass(order.validCode)">{{ getStatusText(order.validCode)
              }}</span>
            </div>
          </div>
          <div class="card-body">
            <div class="sku-image">
              <img :src="order.imageUrl" alt="默认图" />
            </div>
            <div class="sku-info">
              <div class="sku-title">{{ order.skuName }}</div>
              <!-- <div class="sku-sub">
                <span>数量：{{ order.skuNum || '-' }}</span>
                <span>单价：¥{{ order.price || order.skuPrice || '-' }}</span>
              </div> -->
              <div class="sku-sub">
                <span>佣金：{{ order.commissionRate + '%' || '-' }}</span>
                <span>分成比例：{{ toPercent(order.finalRate || order.subSideRate) || '—' }}</span>
              </div>
              <div class="order-meta">
                <span>订单编号：{{ order.orderId }}</span>
                <span class="copy-btn" type="button" @click="copyOrderId(order.orderId)">复制</span>
              </div>
              <div class="order-meta" v-if="isAdmin || isLeader">
                <span>ID：{{ order.positionId }}</span>
                <span class="position-name">名称：{{ order.positionName || '---' }}</span>
              </div>
              <!-- 结算信息：循环展示balanceExt中的结算月份和金额 -->
              <div v-if="order.payMonth != '0'" class="settlement-info">
                <div v-for="(item, index) in parseBalanceExt(order.balanceExt)" :key="index" class="settlement-item">
                  <span class="settlement-label">结算时间：{{ item.month }}</span>
                  <span class="settlement-month"></span>
                  <span class="settlement-amount" :class="{ 'negative': item.amount < 0 }">
                    {{ item.amount >= 0 ? '+' : '保价' }}{{ toFixed2(item.amount) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="card-stats">
            <div class="stat-item">
              <div class="stat-label">购买数量</div>
              <div class="stat-value">{{ order.skuNum || '—' }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">计佣金额</div>
              <div class="stat-value">¥{{ toFixed2(order.actualCosPrice || order.estimateCosPrice) || '—' }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">佣金</div>
              <div class="stat-value">¥{{ toFixed2(order.actualFee || order.estimateFee) || '—' }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 触底加载状态 -->
      <div class="infinite-scroll-container">
        <div v-if="loadingMore" class="loading-more">
          <i class="el-icon-loading"></i>
          <span>加载中...</span>
        </div>
        <div v-if="!hasMore && orderResults.orders && orderResults.orders.length > 0" class="no-more-data">
          没有更多数据了
        </div>
        <div v-else class="no-more-data">暂无数据</div>
      </div>

      <!-- 回到顶部按钮 -->
      <div v-if="showBackToTop" class="back-to-top" @click="scrollToTop">
        <i class="el-icon-top"></i>
      </div>
    </div>

    <!-- 推广链接功能已移至 API测试 页面 -->

    <!-- 自定义时间选择组件 -->
    <CustomTimePicker :visible="showCustomTimePicker" :timeRange="customTimeRange" @close="closeCustomTimePicker"
      @confirm="applyCustomTimeRange" />
  </div>
</template>

<script>
import { syncOrders, syncAllOrders, queryOrders, getCurrentUser, getAllPositions } from '@/utils/jdApi'
import CustomTimePicker from '@/components/CustomTimePicker.vue'

export default {
  name: 'OrderQuery',
  components: {
    CustomTimePicker
  },
  data() {
    return {
      syncing: false,
      querying: false,
      creating: false,
      currentUser: null,
      selectedTimeRange: 'today', // 默认选择今日
      // timeRangeOptions 改为计算属性，根据用户角色动态生成
      statusOptions: [
        { label: '全部', value: 'all' },
        { label: '待付', value: 15 },
        { label: '已付', value: 16 },
        { label: '完成', value: 17 },
        { label: '失效', value: 'invalid' },
      ],
      selectedStatus: 'all',
      syncForm: {
        startTime: '',
        endTime: '',
        timeType: 'orderTime'
      },
      syncAppKeyMode: 'primary',
      queryForm: {
        positionId: '',
        orderId: '',
        skuId: '',
        startTime: '',
        endTime: '',
        timeType: 'order',
        pageIndex: 1,
        pageSize: 10
      },
      orderResults: null,
      positions: [],
      positionMap: new Map(), // 缓存所有推广位信息

      // 触底加载相关
      loadingMore: false,
      hasMore: true,
      showBackToTop: false,

      // 自定义时间范围
      customTimeRange: {
        startDate: '',
        endDate: ''
      },
      showCustomTimePicker: false,

      tabIndex: 0,
    }
  },
  computed: {
    isAdmin() {
      return this.currentUser && this.currentUser.role === 'ADMIN'
    },
    isLeader() {
      return this.currentUser && this.currentUser.role === 'LEADER'
    },
    userPositionId() {
      return this.currentUser ? this.currentUser.positionId : ''
    },
    canSync() {
      return this.syncForm.startTime && this.syncForm.endTime && this.syncForm.timeType
    },
    // 根据用户角色动态生成时间范围选项
    timeRangeOptions() {
      const baseOptions = [
        { label: '今日', value: 'today' },
        { label: '昨日', value: 'yesterday' },
        { label: '一周', value: 'week' },
        { label: '一月', value: 'month' },
        { label: '全部', value: 'all' }
      ]

      // 只有管理员才有自定义选项
      if (this.isAdmin) {
        baseOptions.push({ label: '自定', value: 'custom' })
      }

      return baseOptions
    }
  },
  mounted() {
    this.currentUser = getCurrentUser()
    // 如果是普通用户，自动设置推广位ID
    if (!this.isAdmin && !this.isLeader && this.userPositionId) {
      this.syncForm.positionId = this.userPositionId
      this.queryForm.positionId = this.userPositionId
    }

    // 添加滚动监听
    this.setupScrollListener()

    // 初始化时间范围选项（这里会自动调用queryOrders）
    this.onTimeRangeChange();
    // 管理员和团长加载推广位信息（包含下拉列表和缓存）
    if (this.isAdmin || this.isLeader) {
      this.loadAllPositions()
    }
    // 注意：不需要再次调用this.queryOrders()，因为onTimeRangeChange()已经调用了
  },
  beforeDestroy() {
    this.removeScrollListener()
  },
  methods: {
    getPositionLabel(pos) {
      let label = pos.positionId
      if (pos.positionName) {
        label += ` (${pos.positionName})`
      } else {
        label += ' (---)'
      }

      // 如果是团长，且这是团长自己的推广位，添加【自己】标识
      if (this.isLeader && pos.positionId === this.userPositionId) {
        label += ' 【自己】'
      }

      return label
    },
    statusClass(code) {
      if (code === 15) return 'status-pending'
      if (code === 16) return 'status-paid'
      if (code === 17) return 'status-done'
      if (code === 24) return 'status-deposit'
      const invalidCodes = [2, 3, 4, 5, 6, 7, 8, 9, 11, 13, 14, 19, 20, 21, 22, 23, 25, 26, 27, 28, 29, 30, 31, 33, 34, 35, 36]
      if (invalidCodes.includes(code)) return 'status-invalid'
      return 'status-default'
    },
    copyOrderId(orderId) {
      if (!orderId) return
      try {
        navigator.clipboard.writeText(String(orderId))
      } catch (e) {
        const input = document.createElement('input')
        input.value = String(orderId)
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
      }
    },
    toFixed2(num) {
      const n = Number(num)
      return isNaN(n) ? '' : n.toFixed(2)
    },
    toPercent(num) {
      const n = Number(num)
      return isNaN(n) ? '' : n.toFixed(2) + '%'
    },
    async loadPositions() {
      try {
        const res = await getAllPositions()
        if (res && res.success) {
          this.positions = res.data || []
        }
      } catch (e) {
        console.error('获取推广位失败', e)
      }
    },
    // 从缓存更新推广位下拉列表
    updatePositionsFromCache() {
      if (this.positionMap.size > 0) {
        this.positions = Array.from(this.positionMap.values())
      }
    },

    // 处理时间范围选择
    onTimeRangeSelect(value) {
      this.selectedTimeRange = value
      if (value === 'custom') {
        // 选择自定义时，打开底部弹窗
        this.showCustomTimePicker = true
        return
      }
      this.onTimeRangeChange()
    },

    // 关闭自定义时间选择弹窗
    closeCustomTimePicker() {
      this.showCustomTimePicker = false
      // 如果用户没有选择时间就关闭，重置为今日
      if (!this.customTimeRange.startDate || !this.customTimeRange.endDate) {
        this.selectedTimeRange = 'today'
        this.onTimeRangeChange()
      }
    },

    // 应用自定义时间范围
    applyCustomTimeRange(formattedTimeRange) {
      // 设置查询表单的时间范围
      this.queryForm.startTime = formattedTimeRange.startTime
      this.queryForm.endTime = formattedTimeRange.endTime

      // 关闭弹窗
      this.showCustomTimePicker = false

      // 执行查询
      this.queryOrders()
    },

    // 处理时间范围变化
    onTimeRangeChange() {
      // 清空当前列表
      this.orderResults = null; // 设置为null确保视图更新

      // 使用本地时区格式化日期，而不是UTC
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const today = new Date();
      const yesterday = new Date(today);
      const oneWeekAgo = new Date(today);
      const oneMonthAgo = new Date(today);

      yesterday.setDate(today.getDate() - 1);
      oneWeekAgo.setDate(today.getDate() - 7);
      oneMonthAgo.setMonth(today.getMonth() - 1);

      const todayTime = formatDate(today);
      const yesterdayTime = formatDate(yesterday);
      const oneWeekAgoTime = formatDate(oneWeekAgo);
      const oneMonthAgoTime = formatDate(oneMonthAgo);

      let startTime, endTime;
      switch (this.selectedTimeRange) {
        case 'today':
          startTime = todayTime + ' 00:00:00';
          endTime = todayTime + ' 23:59:59';
          break;
        case 'yesterday':
          startTime = yesterdayTime + ' 00:00:00';
          endTime = yesterdayTime + ' 23:59:59';
          break;
        case 'week':
          startTime = oneWeekAgoTime + ' 00:00:00';
          endTime = todayTime + ' 23:59:59';
          break;
        case 'month':
          startTime = oneMonthAgoTime + ' 00:00:00';
          endTime = todayTime + ' 23:59:59';
          break;
        case 'all':
          // 设置一个较早的时间作为"全部"的开始时间
          startTime = '2020-01-01 00:00:00';
          endTime = todayTime + ' 23:59:59';
          break;
      }
      this.queryForm.startTime = startTime;
      this.queryForm.endTime = endTime;
      this.queryForm.pageIndex = 1;
      this.queryOrders();
    },

    // 状态筛选变化时的处理
    onStatusChange() {
      // 清空当前列表
      this.orderResults = null; // 设置为null确保视图更新
      this.queryForm.pageIndex = 1;
      this.queryOrders();
    },

    // 处理同步时间变化
    onSyncTimeChange() {
      if (this.syncForm.startTime && this.syncForm.endTime) {
        const startTime = new Date(this.syncForm.startTime)
        const endTime = new Date(this.syncForm.endTime)
        const diffHours = (endTime - startTime) / (1000 * 60 * 60)

        if (diffHours > 1) {
          this.$message.warning('开始时间和结束时间不能超过一个小时')
          this.syncForm.endTime = ''
        }
      }
    },

    syncOrders() {
      if (!this.syncForm.startTime || !this.syncForm.endTime) {
        this.$message.warning('请选择开始和结束时间')
        return
      }
      if (!this.syncForm.timeType) {
        this.$message.warning('请选择时间类型')
        return
      }

      this.syncing = true
      syncOrders({
        startTime: this.syncForm.startTime,
        endTime: this.syncForm.endTime,
        timeType: this.syncForm.timeType,
        useSecondary: this.syncAppKeyMode === 'secondary'
      }).then(() => {
        this.$message.success('同步成功')
        // 同步成功后自动查询
        this.queryOrders()
      }).catch(error => {
        console.error('同步失败:', error)
        this.$message.error('同步失败')
      }).finally(() => {
        this.syncing = false
      })
    },

    syncAllOrders() {
      if (!this.syncForm.startTime || !this.syncForm.endTime) {
        this.$message?.warning?.('请填写开始时间和结束时间')
        return
      }

      this.syncing = true
      syncAllOrders({
        startTime: this.formatDateTimeForApi(this.syncForm.startTime),
        endTime: this.formatDateTimeForApi(this.syncForm.endTime)
      }).then(() => {
        // 同步成功后自动查询
        this.queryOrders()
      }).catch(() => {
        this.$message?.error?.('同步失败')
      }).finally(() => {
        this.syncing = false
      })
    },

    queryOrders(isLoadMore = false) {
      if (isLoadMore) {
        this.loadingMore = true
      } else {
        this.querying = true
        this.queryForm.pageIndex = 1 // 重置页码
        // 清空当前列表，准备加载新数据
        this.orderResults = null; // 先设置为null，确保视图更新
        this.hasMore = true // 重置加载状态
      }

      const payload = {
        ...this.queryForm,
        startTime: this.queryForm.startTime,
        endTime: this.queryForm.endTime,
        statusFilter: this.selectedStatus // 添加状态筛选参数
      }

      // 如果positionId是"admin"，转换为"0"
      if (payload.positionId === 'admin') {
        payload.positionId = '0'
      }

      queryOrders(payload).then(response => {
        // 后端直接返回OrderQueryResponse对象，没有success字段
        if (response && response.orders !== undefined) {
          if (isLoadMore) {
            // 触底加载：追加数据
            if (response.orders && response.orders.length > 0) {
              // 检查是否有重复数据
              const existingIds = new Set((this.orderResults?.orders || []).map(order => order.orderId + order.uniqueId))
              const newOrders = response.orders.filter(order =>
                !existingIds.has(order.orderId + order.uniqueId)
              )

              if (newOrders.length > 0) {
                // 直接追加到orderResults.orders
                if (!this.orderResults) {
                  this.orderResults = { orders: [], total: 0 }
                }
                this.orderResults.orders = [...(this.orderResults.orders || []), ...newOrders]
              }

              // 检查是否还有更多数据
              this.hasMore = (this.orderResults?.orders?.length || 0) < response.total
            } else {
              this.hasMore = false
            }
          } else {
            // 首次加载或重新查询：替换数据
            this.orderResults = response
            // 确保页面显示新数据
            this.$nextTick(() => {
              this.$forceUpdate()
            })
          }
          // 如果是管理员或团长，为每个订单添加positionName（使用缓存的推广位信息）
          if ((this.isAdmin || this.isLeader) && this.orderResults && this.orderResults.orders) {
            this.enrichOrdersWithPositionInfo()
          }
        } else {
          // 处理查询失败的情况
          console.error('查询失败: 响应格式错误', response)
          this.$message?.error?.('查询失败: 响应格式错误')
          // 查询失败时也要确保有默认的orderResults
          if (!this.orderResults) {
            this.orderResults = { orders: [], total: 0 }
          }
        }
      }).catch(error => {
        console.error('查询失败:', error)
        this.$message?.error?.('查询失败')
        // 查询失败时也要确保有默认的orderResults
        if (!this.orderResults) {
          this.orderResults = { orders: [], total: 0 }
        }
      }).finally(() => {
        this.querying = false
        this.loadingMore = false
      })
    },

    // 触底加载相关方法
    setupScrollListener() {
      // 现在通过模板的 @scroll 事件绑定，此方法保留为空或用于其他逻辑
    },

    removeScrollListener() {
      // 现在通过模板的 @scroll 事件绑定，此方法保留为空或用于其他逻辑
    },

    handleScroll(event) {
      const scrollContainer = event.target || this.$refs.resultsSection
      if (!scrollContainer) return

      const scrollTop = scrollContainer.scrollTop
      const scrollHeight = scrollContainer.scrollHeight
      const clientHeight = scrollContainer.clientHeight

      // 控制回到顶部按钮显示（滚动超过300px时显示）
      this.showBackToTop = scrollTop > 300

      // 距离底部100px时开始加载
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        this.loadMoreOrders()
      }
    },

    loadMoreOrders() {
      // 防止重复加载
      if (this.loadingMore || this.querying || !this.hasMore) return

      this.loadingMore = true
      this.queryForm.pageIndex++

      const payload = {
        ...this.queryForm,
        startTime: this.queryForm.startTime,
        endTime: this.queryForm.endTime,
        statusFilter: this.selectedStatus
      }

      // 如果positionId是"admin"，转换为"0"
      if (payload.positionId === 'admin') {
        payload.positionId = '0'
      }

      queryOrders(payload).then(response => {
        // 后端直接返回OrderQueryResponse对象，没有success字段
        if (response && response.orders && response.orders.length > 0) {
          // 检查是否有重复数据
          const existingIds = new Set((this.orderResults?.orders || []).map(order => order.orderId + order.uniqueId))
          const newOrders = response.orders.filter(order =>
            !existingIds.has(order.orderId + order.uniqueId)
          )

          if (newOrders.length > 0) {
            // 直接追加到orderResults.orders
            if (!this.orderResults) {
              this.orderResults = { orders: [], total: 0 }
            }
            this.orderResults.orders = [...(this.orderResults.orders || []), ...newOrders]
          }

          // 检查是否还有更多数据
          this.hasMore = (this.orderResults?.orders?.length || 0) < response.total
        } else {
          this.hasMore = false
        }
      }).catch(error => {
        console.error('加载更多订单失败:', error)
        this.queryForm.pageIndex-- // 回退页码
      }).finally(() => {
        this.loadingMore = false
      })
    },

    scrollToTop() {
      const scrollContainer = this.$refs.resultsSection
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },

    formatDateTime(dateTime) {
      if (!dateTime) return '-'
      return new Date(dateTime).toLocaleString('zh-CN')
    },

    /**
     * 解析balanceExt JSON字符串，返回格式化的结算信息数组
     * balanceExt格式：{"20251219":-80.000,"20251120":431.770}
     * 返回：[{month: "2025-12", amount: -80.00}, {month: "2025-11", amount: 431.77}]
     */
    parseBalanceExt(balanceExt) {
      if (!balanceExt || balanceExt === '0' || balanceExt.trim() === '') {
        return []
      }

      try {
        // 解析JSON字符串
        const balanceExtObj = typeof balanceExt === 'string' ? JSON.parse(balanceExt) : balanceExt

        if (!balanceExtObj || typeof balanceExtObj !== 'object') {
          return []
        }

        // 转换为数组并格式化
        const result = []
        for (const [key, value] of Object.entries(balanceExtObj)) {
          // key格式：yyyyMMdd 或 yyyyMM，提取前6位作为月份
          const monthPart = key.length >= 6 ? key.substring(0, 6) : key

          // 格式化月份：202512 -> 2025-12
          let formattedMonth = monthPart
          if (monthPart.length === 6) {
            formattedMonth = `${monthPart.substring(0, 4)}-${monthPart.substring(4, 6)}`
          }

          // 格式化金额
          const amount = Number(value) || 0

          result.push({
            month: formattedMonth,
            amount: amount,
            originalKey: key // 保留原始键用于排序
          })
        }

        // 按月份倒序排列（最新的在前）
        result.sort((a, b) => {
          // 比较原始键，确保正确排序
          return b.originalKey.localeCompare(a.originalKey)
        })

        return result
      } catch (e) {
        console.warn('解析balanceExt失败:', balanceExt, e)
        return []
      }
    },

    formatDateTimeForApi(dateTime) {
      // 将 ISO 格式的时间字符串转换为 yyyy-mm-dd hh:mm:ss 格式
      if (typeof dateTime === 'string' && dateTime.includes('T')) {
        return dateTime.replace('T', ' ') + ':00'
      }
      // 如果已经是Date对象
      return new Date(dateTime).toISOString().slice(0, 19).replace('T', ' ')
    },

    getStatusText(validCode) {
      const statusMap = {
        2: '无效-拆单',
        3: '无效-取消',
        15: '待付款',
        16: '已付款',
        17: '已完成收货',
        24: '已付定金',
      }
      return statusMap[validCode] || '无效'
    },

    // 加载所有推广位信息到缓存
    loadAllPositions() {
      getAllPositions().then(response => {
        if (response && response.success && response.data) {
          // 清空现有缓存
          this.positionMap.clear()
          // 将推广位信息存入Map缓存
          response.data.forEach(position => {
            this.positionMap.set(position.positionId, position)
          })

          // 更新推广位下拉列表
          this.updatePositionsFromCache()
        }
      }).catch(error => {
        console.error('加载推广位信息失败:', error)
      })
    },

    // 为订单添加position信息（使用缓存数据）
    enrichOrdersWithPositionInfo() {
      if (!this.orderResults || !this.orderResults.orders) return

      // 为每个订单添加positionName（从缓存中获取）
      this.orderResults.orders.forEach(order => {
        const position = this.positionMap.get(order.subUnionId || order.positionId)
        if (position) {
          order.positionName = position.positionName || '未命名推广位'
        } else {
          order.positionName = '未知推广位'
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.order-query {
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sync-section,
.query-section,
.promotion-section,
.results-section {
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
}

.query-section {
  background-color: #f9f9f9;
}

.results-section {
  flex: 1;
  overflow-y: auto;
}

.form-group {
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  align-self: center;
}

.form-group label {
  display: inline-block;
  width: 100px;
  font-weight: bold;
  white-space: nowrap;
}

.form-group input,
.form-group select {
  width: 200px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 36px;
  box-sizing: border-box;
  background-color: white;
  color: #333;
  font-size: 14px;
}

/* 下拉框选项样式优化 */
.form-group select {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.form-group select option {
  padding: 8px;
  background-color: white;
  color: #333;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
}

.time-range-options {
  display: flex;
  gap: 15px;
  align-items: center;
}

.filter-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}


.time-range-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}

.range-btn {
  background: white;
  color: #42b983;
  border: 1px solid #42b983;
  padding: 4px 0px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 0px;
  flex: 1;
}

.range-btn.active {
  background: #42b983;
  color: #fff;
}


button {
  background: #42b983;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

button:disabled {
  background: #9dbbad;
  cursor: not-allowed;
}

.stats {
  background: #e8f5e8;
  padding: 0px 10px;
  border-radius: 4px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;

}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
  padding: 4px 0px;
  background: #e8f5e8;
  text-align: center;

  .stat-label {
    font-size: 12px;
    color: #666;
  }

  .stat-value {
    font-size: 16px;
    font-weight: bold;
  }
}

.order-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.order-table th,
.order-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.order-table th {
  background: #f5f5f5;
  font-weight: bold;
}

/* 卡片布局样式 */
.order-cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.order-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 6px;
}

.order-card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fafafa;
  padding: 6px 0px;
}

.order-card .order-time {
  color: #666;
  font-size: 12px;
}

.status-pill {
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
}

.status-paid {
  background: #ff6b6b;
}

.status-done {
  background: #2bb673;
}

.status-pending {
  background: #007bff;
}

.status-invalid {
  background: #9e9e9e;
}

.status-deposit {
  background: #7e57c2;
}

/* .status-default { background: #9e9e9e; } */

.order-card .card-body {
  display: flex;
  gap: 12px;
  margin-bottom: 6px;
}

.sku-image img {
  width: 80px;
  height: 100%;
  object-fit: fill;
  border-radius: 8px;
  background: #f3f3f3;
}

.sku-info {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.sku-title {
  font-weight: 600;
  line-height: 1.4;
  font-size: 13px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 2.8em;
}

.sku-sub {
  color: #666;
  display: flex;
  gap: 16px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.order-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 12px;
}

.copy-btn {
  color: #42b983;
}

.position-name {
  color: #42b983;
  font-weight: 500;
  // background: #f0f8ff;
  // padding: 2px 6px;
  // border-radius: 4px;
  // border-left: 3px solid #42b983;
}

.settlement-info {
  padding: 4px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 12px;
}

.settlement-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.settlement-item:last-child {
  margin-bottom: 0;
}

.settlement-label {
  color: #606266;
}

.settlement-amount {
  color: #42b983;
  font-weight: 600;
  margin-left: auto;
}

.settlement-amount.negative {
  color: #f56c6c;
}

.card-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.stat-label {
  color: #666;
  font-size: 12px;
}

.stat-value {
  font-weight: 700;
  font-size: 14px;
}

@media (min-width: 768px) {
  .order-cards {
    grid-template-columns: 1fr 1fr;
  }
}

.sku-name {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 触底加载样式 */
.infinite-scroll-container {
  text-align: center;
  margin: 20px 0;
  padding: 20px;
}

.loading-more {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #666;
  font-size: 14px;
}

.no-more-data {
  color: #999;
  font-size: 14px;
  padding: 20px;
}

.back-to-top {
  position: fixed;
  bottom: 60px;
  right: 14px;
  width: 35px;
  height: 35px;
  background: #42b983;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 1000;
}

.back-to-top:hover {
  background: #369870;
  transform: translateY(-2px);
}

.back-to-top i {
  font-size: 20px;
}

.promotion-result {
  margin-top: 20px;
}

.promotion-result textarea {
  width: 100%;
  height: 100px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: monospace;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .order-query {
    padding: 10px;
  }

  .sync-section,
  .query-section,
  .promotion-section,
  .results-section {
    padding: 10px;
  }

  .form-group label {
    width: auto;
    display: block;
    /* margin-bottom: 6px; */
  }

  .form-group input,
  .form-group select {
    width: 100%;
    box-sizing: border-box;
  }

  .time-range-options {
    flex-wrap: wrap;
    gap: 10px;
  }

  .time-range-buttons {
    gap: 8px;
  }

  /* 表格容器横向滚动 */
  .results-section {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .order-table {
    min-width: 720px;
  }

  .sku-name {
    max-width: 140px;
  }

  button {
    padding: 8px 12px;
  }
}

::v-deep {

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }

}
</style>